import { createAction } from 'redux-actions';

import { createType, createAsyncTypes, createAsyncActions } from '../../../commons/util/reduxAsync';

export const types = {
	MODAL_LINK_USER: createType('linkUser', 'MODAL_LINK_USER'),
	MODAL_DELETE: createType('linkUser', 'MODAL_DELETE'),

	SEARCH_USER: createAsyncTypes('linkUser', 'SEARCH_USER'),

	GET_USER: createAsyncTypes('linkUser', 'GET_USER'),

	LINK_USER: createAsyncTypes('linkUser', 'LINK_USER'),

	REMOVE_USER: createAsyncTypes('linkUser', 'REMOVE_USER'),

	LOADING: createType('linkUser', 'LOADING')
};

export const actions = {
	modalLinkUser: createAction(types.MODAL_LINK_USER),
	modalDelete: createAction(types.MODAL_DELETE),
	searchUser: createAsyncActions(types.SEARCH_USER),
	getUser: createAsyncActions(types.GET_USER),
	linkUser: createAsyncActions(types.LINK_USER),
	removeUser: createAsyncActions(types.REMOVE_USER),
	handleLoading: createAction(types.LOADING)
};
